import clsx from 'clsx';

import { IProvider } from 'constants/types';

import { Layout } from 'components/layout';
import { CollectionProviders } from './collection-providers';
import { HeaderProvider } from './header';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';
import styles from './styles.module.css';
import { ProvidersDescription } from './description';
import { FAQComponent } from 'components/casino-faq';

export const AllPovidersPage = ({ providers }: { providers: IProvider[] }) => {
  return (
    <div className={styles.container}>
      <CustomMetadata metadata={allMetadata.providers} />
      <Layout hasFooter isSearchInputMobileVisible>
        <main className={clsx(styles.main, styles.main_collection)}>
          <HeaderProvider
            title="The Best Game Providers"
            subTitle="Explore the most renowned game providers that dominate the online casino scene. These companies have earned their reputation by offering high-quality, innovative, and entertaining games for all types of players"
          />
          <CollectionProviders data={providers} />

          <ProvidersDescription />

          <FAQComponent
            customFaq={[
              {
                title:
                  'How do I know which provider to choose when playing online casino games?',
                description:
                  'Choosing a provider depends on your preferences, such as the type of games you enjoy (slots, table games, live dealer games), game quality, bonuses, and features. Many players prefer well-established providers like NetEnt or Microgaming for reliability and a large game selection.',
              },
              {
                title: 'Are the games from these providers fair?',
                description:
                  'Yes, all top providers undergo regular audits and testing by independent third-party organizations to ensure their games are fair and offer random results. Licensed casinos also ensure these providers meet regulatory standards.',
              },
              {
                title:
                  'Can I play games from these providers on mobile devices?',
                description:
                  "Yes, most of the top game providers, including NetEnt, Microgaming, and Play'n GO, design their games with mobile compatibility in mind. Their games are optimized for mobile play, so you can enjoy them on smartphones and tablets.",
              },
              {
                title: 'Do game providers offer free versions of their games?',
                description:
                  'Many providers offer demo versions of their games. These allow players to try out the games without risking any real money, which is great for practice or just to explore new games.',
              },
              {
                title:
                  'Are there any bonuses or promotions related to game providers?',
                description:
                  'Yes, many casinos offer special bonuses or promotions that are tied to specific providers. These can include free spins on certain games or bonuses for playing specific slot machines or table games from a particular provider.',
              },
              {
                title: 'How can I find games from my favorite provider?',
                description:
                  'Most online casinos have a search feature that lets you filter games by provider. You can simply search for the name of the provider or look under the "Providers" category to find games from the developers you enjoy.',
              },
            ]}
          />
        </main>
      </Layout>
    </div>
  );
};
